/**
 * DDDのAggregates
 * query stringのstart、endの値をまとめたクラス
 */
class Params {
  constructor(start, end) {
    this.startObj = start;
    this.endObj = end;
  }

  /**
   * startを返す
   *
   * @returns int|false
   */
  get start() {
    return this.startObj.start;
  }

  /**
   * endを返す
   *
   * @returns int|false
   */
  get end() {
    const _start = this.startObj.start;
    const _end = this.endObj.end;

    // endがfalseならfalseを返す
    if (_end === false) {
      // console.log('end : 1001');
      return false;
    }
    // startがfalseなら大小の比較が出来ないのでendをそのまま返す
    if (_start === false) {
      // console.log('end : 1002');
      return _end;
    }
    // startとendが等しいならfalseを返す
    if (_start === _end) {
      // console.log('end : 1003');
      return false;
    }
    // endよりstartの方が大きい場合はfalseを返す
    if (_start > _end) {
      // console.log('end : 1004');
      return false;
    }
    // console.log('end : 1005');
    return _end;
  }
}

export default Params;
